import {IKitFurniturePriceParam} from '../../../../../../../common-code/interfaces/catalog/IKitFurniturePriceParam';
import {cnCreateForm} from '../../FormModule';
import {Textinput} from '@yandex/ui/Textinput/desktop/bundle';
import React, {useState} from 'react';
import {TDetailCalculateSizes} from '../../../../../../../common-code/types/detail/TDetailCalculateSizes';

interface ModalKitFurnitureSizesProps {
    param: IKitFurniturePriceParam;
    onSizesChange: (name: string, value: string) => void;
}

function ModalKitFurnitureSizes ({param, onSizesChange}: ModalKitFurnitureSizesProps) {
    const [sizes, setSizes] = useState<TDetailCalculateSizes>(param.sizes || {});
    return (
        <div>
            <label htmlFor="sideType">Размеры встраивания (не обязательно)</label>
            <small>
               Для указания размера в процентах перед вводом значения указать %
                (например %100), для указания размера в мм указать число (например 200)
            </small>
            <div className={cnCreateForm("Box-Input")}>
                <div>
                    <label htmlFor="length">Ширина</label>
                    <Textinput
                        className={cnCreateForm("Textinput")}
                        value={sizes.length}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            onSizesChange("length", e.target.value);
                            setSizes({...sizes, length: e.target.value});
                        }}
                        name="length"
                    />
                </div>
                <div>
                    <label htmlFor="height">Высота</label>
                    <Textinput
                        className={cnCreateForm("Textinput")}
                        value={sizes.height}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            onSizesChange("height", e.target.value);
                            setSizes({...sizes, height: e.target.value});
                        }}
                        name="height"
                    />
                </div>
                <div>
                    <label htmlFor="width">Глубина</label>
                    <Textinput
                        className={cnCreateForm("Textinput")}
                        value={sizes.width}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            onSizesChange("width", e.target.value);
                            setSizes({...sizes, width: e.target.value});
                        }}
                        name="width"
                    />
                </div>
            </div>
        </div>
    );
}

export default ModalKitFurnitureSizes;